import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="overflow-hidden rounded-[20px] bg-deep-violet p-7 text-cloud-white md:p-12 lg:p-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </StratosSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
